import React from "react";
import { Grid, TextField, MenuItem, makeStyles } from "@material-ui/core";

import I18nText from "../../../elements/I18nText";
import Section from "../../../elements/Section";
import SectionHeader from "../../../elements/SectionHeader";
import { MAINTENANCE_STATUS } from "../../../domain/maintenance";
import { ALL_VALUE } from "./MaintenanceContainer";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%"
  }
}));

const Filter = ({ values, onChange }) => {
  const classes = useStyles();

  return (
    <Section>
      <SectionHeader>
        <I18nText>devices.maintenance.sections.filter</I18nText>
      </SectionHeader>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            label={<I18nText>devices.maintenance.common.status</I18nText>}
            classes={classes}
            fullWidth
            size="small"
            select
            variant="outlined"
            value={values.status}
            onChange={e => onChange({ ...values, status: e.target.value })}
          >
            <MenuItem value={ALL_VALUE}>
              <I18nText>devices.maintenance.statuses.all</I18nText>
            </MenuItem>
            {Object.values(MAINTENANCE_STATUS).map(status => (
              <MenuItem key={status} value={status}>
                <I18nText>{`devices.maintenance.statuses.${status}`}</I18nText>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Section>
  );
};

export default Filter;
